import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const WarningIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon sx={{ width: props.width || '15px', height: props.height || '16px' }} {...props}>
      <svg
        width={props.width || '15'}
        height={props.height || '16'}
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="error_outline" clipPath="url(#clip0_9554_36934)">
          <path
            id="Vector"
            d="M6.875 9.875H8.125V11.125H6.875V9.875ZM6.875 4.875H8.125V8.625H6.875V4.875ZM7.49375 1.75C4.04375 1.75 1.25 4.55 1.25 8C1.25 11.45 4.04375 14.25 7.49375 14.25C10.95 14.25 13.75 11.45 13.75 8C13.75 4.55 10.95 1.75 7.49375 1.75ZM7.5 13C4.7375 13 2.5 10.7625 2.5 8C2.5 5.2375 4.7375 3 7.5 3C10.2625 3 12.5 5.2375 12.5 8C12.5 10.7625 10.2625 13 7.5 13Z"
            fill="#A3A3A3"
          />
        </g>
        <defs>
          <clipPath id="clip0_9554_36934">
            <rect width="15" height="15" fill="white" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default WarningIcon;
